import { CSSProperties } from 'react';
import { ResponsiveSize, Unit } from '@/shared/types/common';

export const getActualSize = (size?: `${number}${Unit}` | number) => {
  if (!size) return '';
  if (typeof size === 'number') return `${size}px`;
  return size;
};

export const getResponsiveStyle = (
  property: ResponsiveSize,
  variable: string,
  cssProperties?: CSSProperties,
): CSSProperties => {
  const result = cssProperties || ({} as any);

  if (typeof property !== 'object') {
    result[`--${variable}`] = getActualSize(property);
  } else {
    property.desktop;
    result[`--mobile-${variable}`] = getActualSize(property.mobile);
    result[`--desktop-${variable}`] = getActualSize(property.desktop);
  }

  return result as CSSProperties;
};
